
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-stroke",attrs:{"fill":"none","stroke":"#c5c5c5","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"50","stroke-width":"2","d":"M24 15a2 2 0 110 4 2 2 0 010-4zm-6 10c-4-3.866-4-10.134 0-14m-6 18c-5.333-6.075-5.333-15.925 0-22M7 33C-1 24.163-1 9.837 7 1m23 24c4-3.866 4-10.134 0-14m6 18c5.333-6.075 5.333-15.925 0-22m5 26c8-8.837 8-23.163 0-32"}})])
          )
        }
      }
    